import i18next from 'i18next';
import { CURRICULO_COLABORADOR, _URL_FORM, abrirFormCadastro, btnAcoesItensCurriculo, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';
import { uploadArquivo } from './uploads';

export const formacoes = function () {
    "use strict";

    var $divPanel = '#panel-formacao';
    var $panel = body.find($divPanel);


    var _toggleEnsinoMedio = function (edicao) {
        var grauID = $panel.find('#formacao-grau').val();

        if (isNullOrEmpty(grauID)) {
            $('#toggle-formacao').hide();
            return;
        }


        $('#formacao-curso').autocomplete('dispose');


        switch (grauID) {
            case '13':
            case '16':
                $('#toggle-formacao').hide();
                return;
            case '17':
            case '1':
                $panel.find('#row-curso, #row-incompleto').hide();
                $('#toggle-formacao').show();
                return;
            case '3':
                $('#formacao-curso').autocomplete({
                    serviceUrl: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetBacharelado',
                    minChars: 3,
                    deferRequestBy: 250,
                    dataType: 'json',
                    paramName: 'q'
                });
                $panel.find('#row-curso, #row-incompleto').show();
                $('#toggle-formacao').show();
                return;
            default:
                $panel.find('#row-curso, #row-incompleto').show();
                $('#toggle-formacao').show();
                return;
        }
    };

    var _excluir = function (id) {
        swal({
            title: i18next.t('formacaoRemoverTitle'),
            html: i18next.t('formacaoRemoverDescricao'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show($divPanel);
            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteFormacao?id=' + id, cache: false,
                success: function (data) {
                    if (data.success == 1) {
                        body.find('#formacao-item-' + id).remove();
                        toastr.success(i18next.t('formacaoRemoverSucesso'), '', { "closeButton": true });
                        progressoCurriculo();
                        _listar();
                    } else {
                        swal("", data.error, "error");
                    }
                    window.global.loaderPanel.hide($divPanel);
                },
                error: function () {
                    window.global.loaderPanel.hide('#panel-formacao');
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };
    var _listar = function () {
        window.global.loaderPanel.show($divPanel);
        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetFormacoes', cache: false,
            success: function (dados) {
                var dadosLength = dados.length, html = [], item = '', dataInicio = '', dataFim = '', andamento = '';
                var elementNull = document.getElementById("formacao-null");

                if (dadosLength > 0) {
                    elementNull.className = 'hide';
                    for (var i = 0; i < dadosLength; i++) {
                        dataInicio = mesExtenso(dados[i].mesInicio) + ' ' + i18next.t('formacaoDataDe') + ' ' + dados[i].anoInicio;
                        dataFim = mesExtenso(dados[i].mesFim) + ' ' + i18next.t('formacaoDataDe') + ' ' + dados[i].anoFim;
                        // Ano 9999 (DateTime.MaxValue.Year) = data nao extraida/aberta: nao exibir essa ponta.
                        var temInicioFormacao = String(dados[i].anoInicio) !== '9999';
                        var temFimFormacao = String(dados[i].anoFim) !== '9999';
                        var periodoFormacao = temInicioFormacao && temFimFormacao
                            ? i18next.t('formacaoPeriodoEntre').replace('{0}', dataInicio).replace('{1}', dataFim)
                            : temInicioFormacao ? i18next.t('formacaoPeriodoDesde').replace('{0}', dataInicio)
                            : temFimFormacao ? i18next.t('formacaoPeriodoAte').replace('{0}', dataFim)
                            : '';

                        item = '<li class="list-group-item" id="formacao-item-' + dados[i].id + '" data-grau="' + dados[i].grauID + '" data-instituicao="' + dados[i].local + '" data-curso="' + dados[i].curso + '" data-mes-entrada="' + dados[i].mesInicio + '" data-ano-entrada="' + dados[i].anoInicio + '" data-mes-saida="' + dados[i].mesFim + '" data-ano-saida="' + dados[i].anoFim + '" data-mes-entrada="' + dados[i].mesInicio + '" data-incompleto="' + dados[i].incompleto + '" data-certificado="' + dados[i].certificado + '" data-registroClasse="' + dados[i].registroClasse + '">' + btnAcoesItensCurriculo(dados[i].id);
                        item += '<h4 class="nomargin"><b>' + dados[i].grau + '</b></h4>';
                        if (dados[i].grauID != 13 && dados[i].grauID != 16) {
                            item += '<p>';
                            if (dados[i].grauID != 17 && dados[i].grauID != 1) {
                                if (!isNullOrEmpty(dados[i].curso)) {
                                    item += '<b>' + dados[i].curso + '</b> - ';
                                } else {
                                    item += '<span class="alert alert-sm alert-warning cursor-pointer btn-editar mr5" data-id="' + dados[i].id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('formacaoCursoNull') + '</span>';
                                }
                            }
                            if (!isNullOrEmpty(dados[i].local)) {
                                item += '<b>' + dados[i].local + '</b> - ';
                            } else {
                                item += '<span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + dados[i].id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('formacaoInstituicaoNull') + '</span>';
                            }

                            item += '</p>';
                            // Sem uma das pontas nao da para afirmar "cursando"/"concluido": cobra a correcao
                            // em vez de exibir o andamento, que sairia errado (#7891).
                            var faltaConclusaoFormacao = dados[i].temConclusao !== true && dados[i].incompleto !== true;
                            if (temInicioFormacao && !faltaConclusaoFormacao) {
                                item += '<p><span class="text-muted">' + periodoFormacao + ' ' + dados[i].andamentoStr + '</span></p>';
                            } else {
                                item += '<p>';
                                if (temInicioFormacao) {
                                    item += '<span class="text-muted mr5">' + periodoFormacao + '</span>';
                                }
                                item += '<span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + dados[i].id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t(temInicioFormacao ? 'formacaoDataFimNull' : 'formacaoDataNull') + '</span></p>';
                            }

                            if (!isNullOrEmpty(dados[i].certificado) || !isNullOrEmpty(dados[i].registroClasse)) {
                                item += '<ul class="list-inline">';
                                if (!isNullOrEmpty(dados[i].certificado)) {
                                    item += '<li><a href="/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DownloadArquivo?arquivo=' + dados[i].certificado + '&nome=Certificado" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i> ' + i18next.t('downloadCertificado') + '</a></li>';
                                }
                                if (!isNullOrEmpty(dados[i].registroClasse)) {
                                    item += '<li><a href="/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DownloadArquivo?arquivo=' + dados[i].registroClasse + '&nome=Registro de Classe" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i> ' + i18next.t('downladRegistro') + '</a></li>';
                                }
                                item += '</ul>';
                            }
                        }
                        item += '</li>';
                        html.push(item);
                    }
                    document.getElementById('formacao-lista').innerHTML = html.join('');
                    $panel.find('.btn-excluir').on('click', function () {
                        var id = $(this).attr('data-id');
                        _excluir(id);
                    });
                    $panel.find('.btn-editar').on('click', function () {
                        var id = $(this).attr('data-id');
                        _abrir(id);
                    });

                    $panel.find('.btn-add').removeClass('hide');
                } else {
                    elementNull.className = '';
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });
    };
    var _salvar = function () {
        const content = body.find('#form-formacao');
        const grau = content.find('#formacao-grau').val();

        switch (grau) {
            case '13':
            case '16':
                $panel.find('#formacao-curso').val('Ensino Fundamental');
                $panel.find('#formacao-incompleto').attr('checked', false);
                $panel.find('#formacao-instituicao').val('Ensino Fundamental');
                $panel.find('#formacao-mes-entrada').val('1');
                $panel.find('#formacao-ano-entrada').val('1931');
                $panel.find('#formacao-mes-fim').val('1');
                $panel.find('#formacao-ano-fim').val('1932');
                break;
            case '17':
            case '1':
                $panel.find('#formacao-curso').val('Ensino Médio');
                $panel.find('#formacao-incompleto').attr('checked', false);
                break;
        }

        const id = content.find('#formacao-id').val();
        const instituicao = content.find('#formacao-instituicao').val();
        const curso = content.find('#formacao-curso').val();
        const incompleto = content.find('#formacao-incompleto').is(':checked');

        const mesInicio = content.find('#formacao-mes-entrada').val();
        const anoInicio = content.find('#formacao-ano-entrada').val();

        const mesFim = content.find('#formacao-mes-fim').val();
        const anoFim = content.find('#formacao-ano-fim').val();

        const anexoCertificado = content.find('#FormacaoAnexoCertificado').val();
        const anexoRegistroClasse = content.find('#FormacaoAnexoRegistroClasse').val();

        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveFormacao', cache: false,
            data: {
                ID: id,
                GrauID: grau,
                Local: instituicao,
                Curso: curso,
                MesInicio: mesInicio,
                AnoInicio: anoInicio,
                MesFim: mesFim,
                AnoFim: anoFim,
                Incompleto: incompleto,
                AnexoCertificado: anexoCertificado,
                AnexoRegistroClasse: anexoRegistroClasse
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('formacaoSalvaSucesso'), '', { "closeButton": true });
                    if (id == 0) {
                        swal({
                            title: i18next.t('formacaoSalvaOutra'),
                            html: i18next.t('formacaoSalvaOutraDesc'),
                            type: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#40afdf",
                            confirmButtonText: i18next.t('formacaoSalvaAddOutra'),
                            cancelButtonText: i18next.t('btnNaoPossuo'),
                            closeOnConfirm: true
                        }, function (isConfirm) {
                            if (isConfirm) {
                                _abrir(0);
                            }
                        });
                    }

                    _listar();
                    progressoCurriculo();
                    _fechar();


                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };

    var _fechar = function () {
        document.getElementById('formacao-contentform').innerHTML = '';
        goToByScroll($divPanel);
        fecharFormCadastro();
    };
    var _abrir = function (id) {
        goToByScroll($divPanel);

        window.global.loaderFull.show();
        //window.global.loaderPanel.show($divPanel);
        var formulario = body.find('#formacao-contentform');
        var colaborador = CURRICULO_COLABORADOR();
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Formacao?v=2", function () {
            $.validate({
                form: '#form-formacao'
            });
            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            if (colaborador) {
                formulario.find('.formacao-upload').on('click', function (e) {
                    var $this = $(this);
                    uploadArquivo.abrir($this.attr('data-id'), $this.attr('data-titulo'));

                    e.preventDefault();
                });
            } else {
                formulario.find('#box-FormacaoAnexoCertificado, #box-FormacaoAnexoRegistroClasse').addClass('hide');
            }
            formulario.find('#form-formacao').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });

            formulario.find('#formacao-grau').on('change', function () {

                _toggleEnsinoMedio();
            });
            if (id > 0) {
                var item = body.find('#formacao-item-' + id);
                formulario.find('#title-box').html('<i class=\"fa fa-edit mr5\"></i> ' + i18next.t('formacaoEditar'));
                formulario.find('#formacao-grau').val(item.attr('data-grau')).trigger('change');
                formulario.find('#formacao-instituicao').val(item.attr('data-instituicao'));
                formulario.find('#formacao-curso').val(item.attr('data-curso'));

                var formEntradaAberta = item.attr('data-ano-entrada') === '9999';
                formulario.find('#formacao-mes-entrada').val(formEntradaAberta ? '' : item.attr('data-mes-entrada'));
                formulario.find('#formacao-ano-entrada').val(formEntradaAberta ? '' : item.attr('data-ano-entrada'));
                var formFimAberta = item.attr('data-ano-saida') === '9999';
                formulario.find('#formacao-mes-fim').val(formFimAberta ? '' : item.attr('data-mes-saida'));
                formulario.find('#formacao-ano-fim').val(formFimAberta ? '' : item.attr('data-ano-saida'));
                if (item.attr('data-incompleto') == 'true') {
                    formulario.find('#formacao-incompleto').prop('checked', true);
                } else {
                    formulario.find('#formacao-incompleto').prop('checked', false);
                }

                if (!isNullOrEmpty(item.attr('data-certificado'))) {
                    uploadArquivo.templateArquivo('Certificado', item.attr('data-certificado'), 'FormacaoAnexoCertificado', false);
                }

                if (!isNullOrEmpty(item.attr('data-registroClasse'))) {
                    uploadArquivo.templateArquivo('Registro de Classe', item.attr('data-registroClasse'), 'FormacaoAnexoRegistroClasse', false);
                }

                formulario.find('#formacao-id').val(id);

            }

            function OnInput() {
                this.style.height = 0;
                this.style.height = (this.scrollHeight + 50) + "px";
            }

            const tx = document.getElementsByTagName("textarea");
            for (let i = 0; i < tx.length; i++) {
                tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight + 50) + "px;overflow-y:hidden;");
                tx[i].addEventListener("input", OnInput, false);
            }

            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);

            //window.global.loaderPanel.hide($divPanel);
        });


    };

    var _toggleFormacao = function () {

    };


    var init = function () {
        _listar();
        $panel.find('.btn-add').on('click', function (e) {
            _abrir(0);
            e.preventDefault();
        });
    }

    return init();
};

